import API from "../../Network/API";
import { isLoaded, isLoading, manageTasks } from "../actions";

//User stories/MainTasks for Project
export async function getUserStories(dispatch, getUser, id) {
    dispatch(isLoading());
    try {
      var response = await API.post("epic_info.php", {
        "crop": getUser.corp,
        "ideaId": id,
        "action": "maintasks",
        "projectId":getUser.projectId,
        "userType": getUser.role,
        "empId": getUser.empId
      }, {}, false);
      if (response.status === "True") {
        dispatch(manageTasks(response.data));
      } else {
        dispatch(manageTasks([]));
      }
    } catch (error) {
      console.log(error)
    }
    dispatch(isLoaded());
  }